import React, { useState, useEffect } from "react";

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if the user has already accepted or declined cookies
    const consentGiven = localStorage.getItem("cookie-consent");
    if (!consentGiven) {
      setShowBanner(true);
    } else {
      console.log("User has already made a decision, cookie consent:", consentGiven);
    }
  }, []);

  const acceptCookies = () => {
    // Store the user's consent choice
    localStorage.setItem("cookie-consent", "accepted");

    // Update Google Consent Mode to grant consent
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        ad_storage: "granted",
        analytics_storage: "granted",
      });
    }

    setShowBanner(false);
  };

  const declineCookies = () => {
    // Store the user's choice to decline cookies
    localStorage.setItem("cookie-consent", "declined");

    // Update Google Consent Mode to deny consent
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        ad_storage: "denied",
        analytics_storage: "denied",
      });
    }

    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="z-[9999999] fixed inset-x-0 bottom-0 flex flex-col justify-between gap-x-8 gap-y-4 bg-gray-50 p-6 transition-opacity duration-300 ring-1 ring-gray-900/10 md:flex-row md:items-center lg:px-8">
      <p className="max-w-4xl text-sm/6 font-normal text-gray-900">
        We use some essential cookies to make this service work. We&apos;d also like to use analytics cookies so we can understand how you use the service and make improvements.{" "}
        <a href="/privacy-policy" className="text-nowrap font-semibold text-[#002243]">
          cookie policy
        </a>
        .
      </p>
      <div className="flex flex-none items-center gap-x-5">
        <button
          type="button"
          onClick={acceptCookies}
          className="rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
        >
          Accept all
        </button>
        <button
          type="button"
          onClick={declineCookies}
          className="text-sm/6 font-semibold text-gray-900"
        >
          Reject all
        </button>
      </div>
    </div>
  );
}
